/**
 * This file contains styles for the page header
 */
import tw from 'twin.macro';

export const HeaderWrapper = tw.div`text-white lg:h-20 md:text-lg 
font-semibold rounded-r-6xl flex 2xl:w-8/12 lg:w-10/12 md:w-7/12 w-full h-12 text-xs`;

export const HeaderLogo = tw.img`lg:w-20 lg:h-20 w-12 h-12 rounded-r-full`;

export const HeaderTextWrap = tw.div`pl-2 md:pr-7 py-5 -mt-2`;

export const HeaderText = tw.h4``;
